import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { initApp } from './app.actions';

@Injectable()
export class AppDispatcher {
  constructor(private _store: Store<any>) {}

  initApp() {
    this._store.dispatch(initApp());
  }
}
